// extracted by mini-css-extract-plugin
export var container = "styles-module__container___OpWus";
export var communityStat = "styles-module__communityStat___rFjl7";